import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MainNavbar from "../components/navbar";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import { useStopwatch } from "react-timer-hook";
import Chart_page from "../components/chartpage";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MyFooter from "../components/footer";
import AOS from "aos";
import "aos/dist/aos.css";
import Countdown, { zeroPad } from "react-countdown";

import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { getFaqlistAction } from "../ApiAction/api"

gsap.registerPlugin(SplitText);

// function ScrollToTopOnMount() {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   return null;
// }
const stages = [
  {
    title: "Stage 1",
    quarter: "Q1 - 2023",
    items: [
      "Ideation",
      "Proof of Concept",
      "Business Deck",
      "Security Audit",
      "Token on BEP 20",
    ],
  },
  {
    title: "Stage 2",
    quarter: "Q2 - 2023",
    items: [
      "Mainnet Launch",
      "Smart Contract Upgrade",
      "Cross-Chain Interoperability",
      "Governance Model Implementation",
      "Whitepaper Release",
    ],
  },
  {
    title: "Stage 3",
    quarter: "Q3 - 2023",
    items: [
      "Decentralized Finance Expansion",
      "Proof of Concept",
      "Privacy Enhancements",
      "Developer Grants Program",
      "BCL Mobile App",
    ],
  },
  {
    title: "Stage 4",
    quarter: "Q4 - 2023",
    items: [
      "Builder NFT Airdrop",
      "Website Launch",
      "Legal Opinion",
      "NFT Marketplace Launch",
      "Whitepaper Release",
    ],
  },
  {
    title: "Stage 5",
    quarter: "Q5 - 2024",
    items: [
      "Scalability Improvements",
      "Real-World Integration",
      "User-Friendly Wallet",
      "Sustainable Blockchain",
      "Global Community Expansion",
    ],
  },
  // {
  //   title: "Stage 6",
  //   quarter: "Q6 - 2025",
  //   items: [
  //     "AI Integration",
  //     "DAO Expansion",
  //     "Hardware Wallet Support",
  //     "Zero-Knowledge Proof Adoption",
  //     "Cross-Chain NFT Support",
  //   ],
  // },
];
export default function Home(props) {
  useEffect(() => {
    AOS.init();
  }, []);
  // const [activeIndex, setActiveIndex] = useState(0);

  const settings = {
    dots: false,
    infinite: false,
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
    cssEase: "ease-in-out",

    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 430,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const {
    days,
    hours,
    minutes,
    seconds,
    milliseconds,
    isRunning,
    start,
    pause,
    reset,
  } = useStopwatch({ autoStart: true, interval: 20 });


  useEffect(() => {
    // Register GSAP SplitText plugin
    gsap.registerPlugin(SplitText);

    // Ensure the heading is visible before animation
    gsap.set("h1", { opacity: 1 });

    // Split the heading text into characters
    const split = new SplitText("#heading", { type: "chars" });

    // Animate each character
    gsap.from(split.chars, {
      y: 20,
      autoAlpha: 0,
      stagger: 0.05,
    });

    // Cleanup to avoid memory leaks (optional)
    return () => {
      split.revert();
    };
  }, []);


  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <>
        <div>
          <span>{zeroPad(days)}</span>
          <div className="time_tag">Days</div>
        </div>
        <span>:</span>
        <div>
          <span>{zeroPad(hours)}</span>
          <div className="time_tag">Hours</div>
        </div>
        <span>:</span>
        <div>
          <span>{zeroPad(minutes)}</span>
          <div className="time_tag">Minutes</div>
        </div>
        <span>:</span>
        <div>
          <span>{zeroPad(seconds)}</span>
          <div className="time_tag">Seconds</div>
        </div>
      </>
    );
  };

  const [list,setList] = useState([])




  async function getData() {
    try {
      let {status, result } = await getFaqlistAction();
     if(status){
       setList(result)
     }else{
      return false
     }
    } catch (err) {
      console.log(err,"errr");
    }
  }



  useEffect(() =>{
     getData()
  },[])

  return (
    <>
      {/* <ScrollToTopOnMount /> */}
      <header className="page_header">
        <MainNavbar />
        <Container fluid>
          <div className="home-banner-content" name="home">
            <h1 data-aos="fade-up" data-aos-duration="1000">
              Capital and momentum everything your token needs to grow.{" "}
            </h1>

            <p data-aos="fade-up" data-aos-duration="1000">
              Vivamus tristique ultricies lectus, eget egestas nisi pharetra
              dapibus. Praesent quis luctus purus. Donec suscipit eget erat quis
              blandit.
            </p>
            <div
              className="but_text"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <Link
                to="/dashboard"
                className="primary_btn me-4 "
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                BUY Tokens
              </Link>
              <Link
                to="#"
                className="primary_btn grey_btn"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                White Paper
              </Link>
            </div>
            <div className="vector_img"></div>
          </div>
        </Container>
      </header>
      <section
        className="sec_2 section "
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <Container>
          <h5 data-aos="fade-up" data-aos-duration="1000">
            Backed By Leading Blockchain Investors And Founders
          </h5>
          <div
            className="client_img"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <img
              src={require("../assets/images/img4.png")}
              alt=""
              className="img-fluid"
            />
            <img
              src={require("../assets/images/img4.png")}
              alt=""
              className="img-fluid"
            />
            <img
              src={require("../assets/images/img4.png")}
              alt=""
              className="img-fluid"
            />
            <img
              src={require("../assets/images/img4.png")}
              alt=""
              className="img-fluid"
            />
            <img
              src={require("../assets/images/img4.png")}
              alt=""
              className="img-fluid"
            />
            {/* <img
              src={require("../assets/images/img1.png")}
              alt=""
              className="img-fluid"
            />
            <img
              src={require("../assets/images/img2.png")}
              alt=""
              className="img-fluid"
            />
            <img
              src={require("../assets/images/img3.png")}
              alt=""
              className="img-fluid"
            />
            <img
              src={require("../assets/images/img4.png")}
              alt=""
              className="img-fluid"
            />
            <img
              src={require("../assets/images/img5.png")}
              alt=""
              className="img-fluid"
            /> */}
          </div>
        </Container>
      </section>
      <section className="sec_3" data-aos="fade-up" data-aos-duration="1000">
        <Container>
          <div
            className="sec_3_flex"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <div className="timing_sec">
              <h6 data-aos="fade-up" data-aos-duration="1000">
                Pre Sale Live Now
              </h6>

              <div
                className="timer_sec"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <Countdown
                  date={`2025-06-05T20:00:59`}
                  renderer={renderer}
                />
              </div>
            </div>

            <div
              className="progress-wrap"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <h6 data-aos="fade-up" data-aos-duration="1000">
                <span>$45,256,432</span> Contribution Receive
              </h6>
              <ul className="list-wrap">
                <li>Pre-Sale</li>
                <li>soft cap</li>
                <li>bonus</li>
              </ul>
              <div
                className="progress"
                role="progressbar"
                aria-label="Example with label"
                aria-valuenow={83}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                <div className="progress-bar" style={{ width: "23%" }} />
              </div>
              <p className="progress-title">
                {" "}
                100 Target Raised <span>1 BNB = $1000 = 3177.38 WAIQ</span>
              </p>
            </div>
          </div>
        </Container>
      </section>
      <section
        className="sec_4 section"
        name="about"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <Container>
          <Row className="align-items-center">
            <Col lg="6">
              <h2 data-aos="fade-up" data-aos-duration="1000">
                We’ve built a platform to buy and sell shares.
              </h2>
              <p data-aos="fade-up" data-aos-duration="1000">
                Crypto ICO is a blockchain-powered marketplace where buyers and
                sellers connect to trade digital goods and assets using
                cryptocurrency. What sets Crypton apart is its AI-driven user
                matching system, intelligently pairing users based on their
                preferences and behavior. As the world’s first AI-integrated
                marketplace, Crypton fuses traditional systems with smart
                contracts and forward-thinking blockchain technology—creating a
                future-ready platform for seamless, personalized digital
                transactions.
              </p>
            </Col>
            <Col lg="6" className="d-none d-lg-block">
              <div
                className="img_2"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="img_2head">
                  <img
                    src={require("../assets/images/image_2.png")}
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="sec_5" name="tokensale">
        <Container>
          <div
            className="heading_sec"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h2 data-aos="fade-up" data-aos-duration="1000">
              Live Token Market Updates
            </h2>
            <p data-aos="fade-up" data-aos-duration="1000">
              Stay Informed with Live Data and Analysis
            </p>
          </div>
          <div className="token_market">
            <div className="token_market_head">
              <h6 data-aos="fade-up" data-aos-duration="1000">
                Information About Tokens
              </h6>
              <div className="box" data-aos="fade-up" data-aos-duration="1000">
                <div className="box_bg">Token Name</div>
                <div>Nominal Price</div>
              </div>
              <div className="box" data-aos="fade-up" data-aos-duration="1000">
                <div className="box_bg">Token Name</div>
                <div>Nominal Price</div>
              </div>
              <div className="box" data-aos="fade-up" data-aos-duration="1000">
                <div className="box_bg">Token Name</div>
                <div>Nominal Price</div>
              </div>
              <div className="box" data-aos="fade-up" data-aos-duration="1000">
                <div className="box_bg">Token Name</div>
                <div>Nominal Price</div>
              </div>
              <div className="box" data-aos="fade-up" data-aos-duration="1000">
                <div className="box_bg">Token Name</div>
                <div>Nominal Price</div>
              </div>
            </div>
            <div
              className="token_market_head"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <h6>Information About Tokens</h6>
              <div className="box" data-aos="fade-up" data-aos-duration="1000">
                <div className="box_bg">Token Name</div>
                <div>Nominal Price</div>
              </div>
              <div className="box" data-aos="fade-up" data-aos-duration="1000">
                <div className="box_bg">Token Name</div>
                <div>Nominal Price</div>
              </div>
              <div className="box" data-aos="fade-up" data-aos-duration="1000">
                <div className="box_bg">Token Name</div>
                <div>Nominal Price</div>
              </div>
              <div className="box" data-aos="fade-up" data-aos-duration="1000">
                <div className="box_bg">Token Name</div>
                <div>Nominal Price</div>
              </div>
              <div className="box" data-aos="fade-up" data-aos-duration="1000">
                <div className="box_bg">Token Name</div>
                <div>Nominal Price</div>
              </div>
            </div>
          </div>

          <div>
            <div
              className="chart_head"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div
                className="chat_base"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  gap: "0 60px",
                }}
              >
                <Chart_page />
              </div>
            </div>
          </div>
        </Container>
      </section>
      {/* <section className="sec_6 section">
        <Container>
          <div className="heading_sec">
            <h2>Roadmap</h2>
            <p>blockchain a Solid Infrastructure for Growth</p>
          </div>
          <div className="timeline-wrapper">
            <div className="timeline-track" />
            <Slider {...settings}>
              {stages.map((stage, index) => (
                <div
                  key={index}
                  className={`timeline-item ${
                    index === activeIndex ? "active-slide" : ""
                  }`}
                >
                  <div className="timeline-dot" />
                  <div className="timeline-line" />{" "}
                  <div className="stage-card-wrapper">
                    <div className="stage-card">
                      <h3>{stage.title}</h3>
                      <p className="quarter">{stage.quarter}</p>
                      <ul>
                        {stage.items.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                 
                </div>
              ))}
            </Slider>
          </div>
        </Container>
      </section> */}
      <section
        className="slide_sec section"
        name="roadmap"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <Container>
          <div className="heading_sec">
            <h2 data-aos="fade-up" data-aos-duration="1000">
              Roadmap
            </h2>
            <p data-aos="fade-up" data-aos-duration="1000">
              blockchain a Solid Infrastructure for Growth
            </p>
          </div>
          <div>
            <div
              className="timeline-wrapper"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div className="timeline-track" />
              <Slider {...settings}>
                <div className="timeline-item timeline-item-top">
                  <div className="stage-card-wrapper">
                    <div className="stage-card">
                      <h3>{stages[0].title}</h3>
                      <p className="quarter">{stages[0].quarter}</p>
                      <ul>
                        {stages[0].items.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="stage-card-wrapper">
                    <div className="stage-card">
                      <h3>{stages[1].title}</h3>
                      <p className="quarter">{stages[1].quarter}</p>
                      <ul>
                        {stages[1].items.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="timeline-item timeline-item-top">
                  <div className="stage-card-wrapper">
                    <div className="stage-card">
                      <h3>{stages[2].title}</h3>
                      <p className="quarter">{stages[2].quarter}</p>
                      <ul>
                        {stages[2].items.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="stage-card-wrapper">
                    <div className="stage-card">
                      <h3>{stages[3].title}</h3>
                      <p className="quarter">{stages[3].quarter}</p>
                      <ul>
                        {stages[3].items.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="timeline-item timeline-item-top">
                  <div className="stage-card-wrapper">
                    <div className="stage-card">
                      <h3>{stages[4].title}</h3>
                      <p className="quarter">{stages[4].quarter}</p>
                      <ul>
                        {stages[4].items.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                {/* <div className="timeline-item ">
                  <div className="stage-card-wrapper">
                    <div className="stage-card">
                      <h3>{stages[5].title}</h3>
                      <p className="quarter">{stages[5].quarter}</p>
                      <ul>
                        {stages[5].items.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div> */}
              </Slider>
            </div>
          </div>
        </Container>
      </section>
      <section
        className="faq section"
        name="faq"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <Container>
          <div className="heading_sec">
            <h2 data-aos="fade-up" data-aos-duration="1000">
              Ask Quick Questions
            </h2>
          </div>
          <Row
            className="justify-content-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <Col lg={8}>
              <Accordion
                defaultActiveKey={["0"]}
                className="acc_main"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {list && list.length > 0 && list.map((value,i) =>{
                  return(
                 <Accordion.Item
                  eventKey={`${i}`}
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <Accordion.Header>{value?.question}</Accordion.Header>
                  <Accordion.Body>
                   {value?.answer}
                  </Accordion.Body>
                 </Accordion.Item>
                 )
                })}
                {/* <Accordion.Item
                  eventKey="0"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <Accordion.Header>What is Blockchain?</Accordion.Header>
                  <Accordion.Body>
                    Blockchain uses consensus mechanisms, such as Proof of Work
                    (PoW) or Proof of Stake (PoS), to validate and agree on the
                    state of the network. These mechanisms require participants
                    (nodes or validators) to solve complex mathematical puzzles
                    or stake cryptocurrency to participate in the consensus
                    process.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="1"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <Accordion.Header>How is Blockchain Secure?</Accordion.Header>
                  <Accordion.Body>
                    Blockchain uses consensus mechanisms, such as Proof of Work
                    (PoW) or Proof of Stake (PoS), to validate and agree on the
                    state of the network. These mechanisms require participants
                    (nodes or validators) to solve complex mathematical puzzles
                    or stake cryptocurrency to participate in the consensus
                    process.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="2"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <Accordion.Header>
                    What is the Difference Between Public and Private
                    Blockchains?
                  </Accordion.Header>
                  <Accordion.Body>
                    Blockchain uses consensus mechanisms, such as Proof of Work
                    (PoW) or Proof of Stake (PoS), to validate and agree on the
                    state of the network. These mechanisms require participants
                    (nodes or validators) to solve complex mathematical puzzles
                    or stake cryptocurrency to participate in the consensus
                    process.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="3"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <Accordion.Header>
                    How Can I Get Started with Blockchain?
                  </Accordion.Header>
                  <Accordion.Body>
                    Blockchain uses consensus mechanisms, such as Proof of Work
                    (PoW) or Proof of Stake (PoS), to validate and agree on the
                    state of the network. These mechanisms require participants
                    (nodes or validators) to solve complex mathematical puzzles
                    or stake cryptocurrency to participate in the consensus
                    process.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="4"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <Accordion.Header>
                    What Are Some Real-World Use Cases of Blockchain?
                  </Accordion.Header>
                  <Accordion.Body>
                    Blockchain uses consensus mechanisms, such as Proof of Work
                    (PoW) or Proof of Stake (PoS), to validate and agree on the
                    state of the network. These mechanisms require participants
                    (nodes or validators) to solve complex mathematical puzzles
                    or stake cryptocurrency to participate in the consensus
                    process.
                  </Accordion.Body>
                </Accordion.Item> */}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
      <MyFooter />
    </>
  );
}
